import axiosInstance, { getAccessToken } from './axiosConfig';
import { requireAuthToken } from '../utils/authUtils';

const storeAPI = {
  /**
   * Get all stores for the current tenant
   * @returns {Promise} Array of stores
   */
  getAll: async () => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.get('/store');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch stores';
    }
  },

  /**
   * Create a new store
   * @param {object} storeData - Store data (name, location)
   * @returns {Promise} Created store
   */
  create: async (storeData) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.post('/store', storeData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create store';
    }
  },

  /**
   * Update a store
   * @param {string} id - Store ID
   * @param {object} updates - Store updates
   * @returns {Promise} Updated store
   */
  update: async (id, updates) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.put(`/store/${id}`, updates);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update store';
    }
  },

  /**
   * Delete a store
   * @param {string} id - Store ID
   * @returns {Promise} Success message
   */
  delete: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.delete(`/store/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete store';
    }
  },

  /**
   * Get store by ID
   * @param {string} id - Store ID
   * @returns {Promise} Store details
   */
  getById: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.get(`/store/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch store';
    }
  }
};

export default storeAPI;